import type { Diet, MealType, SourceType } from '@dishly/shared';
import { m } from '../../paraglide/messages.js';

/** UI labels for the recipe vocabularies (packages/shared/src/recipe.ts). */
export const mealTypeLabel: Record<MealType, () => string> = {
  breakfast: m.meal_breakfast,
  lunch: m.meal_lunch,
  dinner: m.meal_dinner,
  snack: m.meal_snack,
  dessert: m.meal_dessert,
};

export const dietLabel: Record<Diet, () => string> = {
  vegetarian: m.diet_vegetarian,
  vegan: m.diet_vegan,
  pescatarian: m.diet_pescatarian,
  gluten_free: m.diet_gluten_free,
  dairy_free: m.diet_dairy_free,
  high_protein: m.diet_high_protein,
  low_carb: m.diet_low_carb,
};

export const sourceLabel: Record<SourceType, () => string> = {
  youtube: () => 'YouTube',
  instagram: () => 'Instagram',
  tiktok: () => 'TikTok',
  x: () => 'X',
  facebook: () => 'Facebook',
  web: m.source_web,
  text: m.source_text,
  image: m.source_image,
  notion: () => 'Notion',
  manual: m.source_manual,
};
